import { component, prop } from '../../../decorators';

@component
export default class Ellipsis {
   @prop({ type: String, required: true }) text
   @prop({ type: Number, required: true }) length

   get needCollapse() {
      return this.text.length > this.length;
   }

   get title() {
      return this.needCollapse ? this.text : '';
   }
}
